import {CreateOrderData, EventData, OrderData, SegmentsDiscounts} from "@/@types/api";

function getFireUrl(apiUrl: string) {
    return apiUrl
        .replace('https://', '')
        .replace('http://', '')
        .replace('api.ticketcafe.ru:449/', '')
        .replace('api.ticketcafe.ru/', '')
        .replace(/[/]/g, '-')
        .replace(/[.!:]/g, '')
}

//const ROOT_URL = 'https://api.ticketcafe.ru/widget2/hs/widget/'
//export const API_URL = 'https://api.ticketcafe.ru:449/widget2.dev/hs/widget'
export const API_URL = process.env.VUE_APP_API_URL ?? ''
export const FIRE_URL = getFireUrl(API_URL)

let originDomain = ""

export function setOriginDomain(domain: string) {
    originDomain = domain
}

async function request<T>(input: string, init?: RequestInit): Promise<T> {
    const response = await fetch(input, init)

    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }

    return response.json()
}

// Для файловой базы лучше под общим юзером на стороне apache,
// чтобы в рамках единой сессии.
//const authConfig = {}//{auth: {username: 'backstage', password: '55Fk9843756Bd'}}

export async function getEvent(eventId: string): Promise<EventData | null> {
    // if (!eventId) return undefined;
    //return (await request<{ data: EventData }>(`${API_URL}/events/${eventId}`)).data

    try {
        return (await request<{ data: EventData }>(`${API_URL}/events/${eventId}?domain=${originDomain}`)).data
    } catch {
        return null
    }
}

export async function createOnlineOrder(data: CreateOrderData, paymentSystem: string): Promise<OrderData> {
    return (
        await request<{ data: OrderData }>(
            `${API_URL}/online-orders?domain=${originDomain}&paymentSystem=${paymentSystem}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }
        )
    ).data
}

export async function getPromocodeData(eventId: string, promocode: string, segments: number[]): Promise<SegmentsDiscounts> {
    const params = new URLSearchParams({
        domain: originDomain,
        segments: segments.join(','),
    })
    const responseData = (
        await request<{ data: { [segmentId: string]: number } }>(
            `${API_URL}/promocode/${eventId}/${promocode}?${params.toString()}`
        )
    ).data

    const segmentDiscounts: SegmentsDiscounts = new Map
    for (const key in responseData) {
        segmentDiscounts.set(Number(key), responseData[key])
    }

    return segmentDiscounts
}
